import { computed, ref, watch } from 'ui.vue3';
import { defineStore } from 'ui.vue3.pinia';

export default defineStore('calculator', () => {

  const dialogArendaForm = ref(false);

  const dialogEnterpriseForm = ref(false);

  const dialogFreshForm = ref(false);

  const groups = ref([]);

  const isFresh = computed(() => 'arenda' === tariff.value?.type && program.value?.fresh);

  const isFreshKz = computed(() => 'fresh_kz' === tariff.value?.type);

  const isArenda = computed(() => 'arenda' === tariff.value?.type && !program.value?.fresh);

  const isEnterprise = computed(() => 'enterprise' === tariff.value?.type);

  const period = computed(() => periods.value.find(p => p.id === selectedPeriod.value));

  const periods = ref([]);

  const program = computed(() => programs.value.find(p => p.id === selectedProgram.value));

  const programs = ref([]);

  const priceDate = ref('');

  const priceDetailsUrl = ref('');

  const tariffs = ref([]);

  const selectedBases = ref(1);

  const selectedUsers = ref(1);

  const selectedPeriod = ref('');

  const selectedProgram = ref('');

  const selectedTariff = ref('');

  const selectedGroup = computed(() => {
    for (const group of groups.value) {
      if (group.programs.includes(selectedProgram.value)) {
        return group;
      }
    }
    return null;
  });

  const services = ref('');

  const servicesAvailable = computed(() => {
      if (!selectedTariff.value || !selectedProgram.value || !selectedPeriod.value) {
          return [];
      }
      const result = [];
      for (let service of services.value) {
         for (let tariff of service.tariffs) {
             if (tariff.id === selectedTariff.value) {
                 let programOk = true;
                 if (tariff.programs.length > 0) {
                     programOk = false;
                     for (let program of tariff.programs) {
                         if (program === selectedProgram.value) {
                             programOk = true;
                             break;
                         }
                     }
                 }
                 let periodOk = true;
                 if (tariff.min_duration) {
                     periodOk = false;
                     for (let period of periods.value) {
                        if (period.id === selectedPeriod.value) {
                            if (tariff.min_duration <= period.months) {
                                periodOk = true;
                            }
                            break;
                        }
                     }
                 }
                 if (programOk && periodOk) {
                     result.push({
                         id: service.id,
                         name: service.name,
                         description: service.description,
                         value: tariff.value,
                     });
                 }
                 break;
             }
         }
      }
      return result;
  });

  const subscriptionUrl = ref('');

  const tariff = computed(() => tariffs.value.find(t => t.id === selectedTariff.value));

  const tariffsAvailable = computed(() => {
    const tariffsList = [];
    for (const tariff of tariffs.value) {
      let tariff_meet_params = (
        tariff.groups.find(t => t.group_id === selectedGroup.value?.id) !== undefined
        && tariff.periods.find(p => p.period_id === selectedPeriod.value) !== undefined
      );
      if (tariff.min_users !== null && selectedUsers.value < tariff.min_users) {
        tariff_meet_params = false;
      }
      if (tariff.max_users !== null && selectedUsers.value > tariff.max_users) {
        tariff_meet_params = false;
      }
      if (tariff.min_bases !== null && selectedBases.value < tariff.min_bases) {
          tariff_meet_params = false;
      }
      if (tariff.max_bases !== null && selectedBases.value > tariff.max_bases) {
          tariff_meet_params = false;
      }
      tariff.available = tariff_meet_params;
      if ((tariff.available || tariff.show_always) && tariffsList.filter(t => t.type === tariff.type).length === 0) {
          tariffsList.push(tariff);
      }
    }

    return tariffsList;
  });

  const total = computed(() => {
    let total = 0;
    const period = periods.value.find(p => p.id === selectedPeriod.value);
    const tariff_group = tariff.value?.groups.find(g => g.group_id === selectedGroup.value?.id);
    if (period && tariff_group) {
      if (selectedUsers.value > tariff.value.included_users && tariff_group.price_per_user) {
        if (Array.isArray(tariff_group.price_per_user)) {
          for (const price_per_user of tariff_group.price_per_user) {
            if (
              (
                (
                  price_per_user.min
                  && price_per_user.min <= selectedUsers.value
                )
                || null === price_per_user.min
              )
              && (
                (
                  price_per_user.max
                  && price_per_user.max >= selectedUsers.value
                )
                || null === price_per_user.max
              )
            ) {
              total += period.months * price_per_user.price * (selectedUsers.value - tariff.value.included_users);
              break;
            }
         }
        } else {
          total += period.months * tariff_group.price_per_user * (selectedUsers.value - tariff.value.included_users);
        }
      }
      if (selectedBases.value > tariff.value.included_bases && tariff_group.price_per_base) {
        if (Array.isArray(tariff_group.price_per_base)) {
          for (const price_per_base of tariff_group.price_per_base) {
            if (
              (
                (
                  price_per_base.min
                  && price_per_base.min <= selectedBases.value
                )
                || null === price_per_base.min
              )
              && (
                (
                  price_per_base.max
                  && price_per_base.max >= selectedBases.value
                )
                || null === price_per_base.max
              )
            ) {
              total += period.months * price_per_base.price * (selectedBases.value - tariff.value.included_bases);
              break;
            }
          }
        } else {
          total += period.months * tariff_group.price_per_base * (selectedBases.value - tariff.value.included_bases);
        }
      }
      if (isFreshKz.value) {
        const tariff_period = tariff.value.periods.find(p => p.period_id = selectedPeriod.value);
        if (tariff_period) {
          total += tariff_period.price;
        }
      }
    }
    if (total > 0) {
      return Intl.NumberFormat().format(total);
    }
    return '';
  });

  const whereDoYouKnow = ref([]);

  const arendaOfferUrl = ref('');

  watch(tariffsAvailable, newTariffs => {
      if (newTariffs.length === 0)  return;

      for (const t of newTariffs) {
          if (t.default) {
              selectedTariff.value = t.id;
              return;
          }
      }

      for (const t of newTariffs) {
          if (t.available) {
              selectedTariff.value = t.id;
              return;
          }
      }
  });

  return {
    dialogArendaForm,
    dialogEnterpriseForm,
    dialogFreshForm,
    groups,
    isArenda,
    isEnterprise,
    isFresh,
    isFreshKz,
    period,
    periods,
    priceDate,
    priceDetailsUrl,
    program,
    programs,
    tariffs,
    selectedBases,
    selectedGroup,
    selectedUsers,
    selectedPeriod,
    selectedProgram,
    selectedTariff,
    services,
    servicesAvailable,
    subscriptionUrl,
    tariff,
    tariffsAvailable,
    total,
    whereDoYouKnow,
    arendaOfferUrl,
  };
});
